import { render, staticRenderFns } from "./exhibition-template-new-brand.vue?vue&type=template&id=2cff7d93&scoped=true&"
import script from "./exhibition-template-new-brand.vue?vue&type=script&lang=js&"
export * from "./exhibition-template-new-brand.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-template-new-brand.vue?vue&type=style&index=0&id=2cff7d93&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cff7d93",
  null
  
)

export default component.exports